/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useState } from "react";
import { IconSelectorDialog } from "cms/icons/icon-selector/index";
import { IconButton, Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SVGIcons } from "cms/icons/svg-icons";

const IconSelectorView = (props) => {

    // const { t } = useTranslation()
    const {
        icon,
        setIcon,
        onChangeIcon,
        onRemoveIcon,
    } = props;

    const dynamicIcon = `fa-solid ${icon}`;
    const [open, setOpen] = useState();

    const handleEditIcon = () => {
        setOpen(true);
    };
    const handleRemoveIcon = () => {
        onRemoveIcon();
    };

    return (
        <Fragment>
            <div className='icon-link-selector-container'>

                {/* icon empty */}
                {!icon &&
                    <div className='icon-link-selector-icon-empty'>
                        <Button
                            variant='text'
                            onClick={handleEditIcon}
                        >
                            Select Icon
                        </Button>
                    </div>
                }

                {icon &&
                    <>
                        {/* icon */}
                        <div className='icon-link-selector-icon-display'>
                            <FontAwesomeIcon
                                icon={dynamicIcon}
                                size='1x'
                                color={"#7A7A7A"}
                            />
                        </div>

                        {/* icon name */}
                        <div className='icon-link-selector-icon-name'>
                            {icon}
                        </div>
                    </>
                }
            </div>

            {/* icon edit delete buttons */}
            <div className='icon-link-selector-icon-buttons'>
                {icon &&
                    <>
                        <IconButton
                            size='small'
                            title={"Edit"}
                            edge='end'
                            onClick={handleEditIcon}
                        >
                            <SVGIcons.common.Edit style={{ cursor: "pointer" }} />
                        </IconButton>
                        <IconButton
                            size='small'
                            title={"Edit"}
                            edge='end'
                            onClick={handleRemoveIcon}
                        >
                            <SVGIcons.common.Delete style={{ cursor: "pointer" }} />
                        </IconButton>
                    </>
                }
            </div>

            <IconSelectorDialog
                icon={icon}
                setIcon={setIcon}
                onSelectIcon={onChangeIcon}
                open={open}
                setOpen={setOpen}
            />
        </Fragment>
    );
};

export { IconSelectorView };
